import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

/**
 * "Bad debt" pill (Change #100090).
 *
 * Shown against an invoice that has been written off as a bad debt
 * (Invoice.BadDebtWriteOff_Id). It sits where the overdue pill would be: a
 * written-off invoice is no longer being chased, so "Overdue 3 months" would
 * be the wrong thing to say about it. Links to the write-off.
 *
 * Rows without the field (backend not deployed, or the delta not run yet)
 * simply show nothing.
 */

// True when the invoice row has been written off. Also used as part of the
// "settled" test for OverdueByPill and the Overdue tabs.
export const isWrittenOff = (invoice) => Number(invoice?.BadDebtWriteOff_Id || 0) > 0;

export default function BadDebtPill({ invoice }) {
  if (!isWrittenOff(invoice)) return null;

  const writtenOff = invoice?.BadDebtWriteOff_BadDebtDateTime
    ? moment(invoice.BadDebtWriteOff_BadDebtDateTime).format("D MMM YYYY")
    : null;

  return (
    <Link
      to={`/bad-debt-list/${invoice.BadDebtWriteOff_Id}`}
      className="badge bg-dark text-white ms-1 text-decoration-none"
      title={`Written off as bad debt #${invoice.BadDebtWriteOff_Id}${
        writtenOff ? ` on ${writtenOff}` : ""
      }${invoice?.BadDebtWriteOff_Title ? ` - ${invoice.BadDebtWriteOff_Title}` : ""}`}
      onClick={(e) => e.stopPropagation()}
    >
      <i className="ri-close-circle-line align-bottom me-1"></i>
      Bad debt
    </Link>
  );
}
